import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { tasks as tasksApi } from 'redux/modules/api'
import { areAllSelectedForBulk, mapAwardsForBulk } from 'redux/selectors/awardLeaderAssignments'
import { logError, modal, notification } from 'redux/modules/app'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      state => ({
        tasks: state.api.tasks.unassignedParticipants,
        selectableAwardIds: mapAwardsForBulk(state),
        areAllAwardsSelected: areAllSelectedForBulk(state),
        commonLimit: state.app.commonLimit
      }),
      {
        ...tasksApi.unassignedParticipants,
        notification,
        modal,
        logError,
        bulkSelectAwards: tasksApi.unassignedParticipants.toggleTasksUnassignedParticipantsAllSelected
      }
    )
    class TasksUnassignedParticipants extends Component {
      static propTypes = {
        tasks: PropTypes.object.isRequired,
        getTasksUnassignedParticipants: PropTypes.func.isRequired,
        modal: PropTypes.func,
        logError: PropTypes.func.isRequired,
        setTasksUnassignedParticipantsSelected: PropTypes.func,
        commonLimit: PropTypes.number,
        setUnassignedParticipantsParams: PropTypes.func
      }

      componentDidMount() {
        const { commonLimit, setUnassignedParticipantsParams } = this.props
        let tasks = this.props.tasks

        if (config.useCommonLimit && commonLimit) {
          tasks = {
            ...tasks,
            limit: commonLimit
          }
          setUnassignedParticipantsParams({ limit: commonLimit })
        }

        config.list && this.handleGetTasksUnassignedParticipants(tasks)
      }

      componentWillReceiveProps(nextProps) {
        const { tasks } = this.props
        const { filter, limit, offset, sort } = nextProps.tasks

        if (
          tasks.filter !== filter ||
          tasks.limit !== limit ||
          tasks.offset !== offset ||
          tasks.sort !== sort
        ) {
          config.list &&
            this.handleGetTasksUnassignedParticipants(nextProps.tasks)
        }
      }

      handleGetTasksUnassignedParticipants = tasks =>
        this.props.getTasksUnassignedParticipants(tasks)

      handleSetAwardsSelectedTo = (id, newVal) => {
        const ids = this.props.tasks.selectedIds || []
        const newIds = ids.filter(i => i !== id).concat(newVal ? [id] : [])

        this.props.setTasksUnassignedParticipantsSelected(newIds)
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            setAwardsSelectedTo={this.handleSetAwardsSelectedTo}
          />
        )
      }
    }
    return TasksUnassignedParticipants
  }
}

export default decorator
